import {decimalFormat, moneyToFixedFormat} from "../../../common/StringUtils";
import React from "react";
import {atom} from "jotai";

export const lockedReportRows = [
  {
    position: 'start',
    cellStyle : {
      display: 'flex',
      justifyContent: 'center',
      fontWeight: 'bold',
      fontSize: '18px'
    },
    render: {
      statisticsDate: 'Total',
      statisticsHour: 'Total',
      adverName: 'Total',
      campaignName: 'Total',
      allowInventoryIds: '-',
      inventoryId: '-',
      userId: '-',
      exposureCount: ({ summary }) => <p className={'ellipsis'}>{decimalFormat(summary.exposureCount)}</p>,
      costAmount: ({ summary }) => <p className={'won ellipsis'} style={{color: '#c55'}}>{moneyToFixedFormat(summary.costAmount)}</p>,
      eCpm: ({ summary }) => <p className={'won ellipsis'} style={{color: '#5c5'}}>{summary.exposureCount !== 0 ? moneyToFixedFormat((summary.costAmount / summary.exposureCount) * 1000) : summary.eCpm}</p>,
    }
  }
]
export const rowDetailsDataAtom = atom([]);
export const tableIdAtom = atom(null);
